import { colors } from '../foundation';

type Props = {
  color?:
    | typeof colors.primary.grey
    | typeof colors.primary.white
    | typeof colors.primary.red
    | (typeof colors.grey)[100]
    | (typeof colors.neutral)[10]
    | 'currentColor';
  size?: string;
};

const Close = ({ color = colors.primary.grey, size = '24' }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M5.5 18.5L18.5 5.5M18.5 18.5L5.5 5.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default Close;
